export default __webpack_public_path__ + "static/media/course4.1b70eb8a.webp";